<template>
    <div class="pl-3 pr-2" style="width: 100% !important">
        <v-row no-gutters>
            <v-col cols="12">
                <v-row class=" pr-1 mt-2 pa-0" dense >
                    <!-- // * DESCRIPTION -->
                    <v-col cols="12">
                        <v-row no-gutters class="">
                            <v-col class="px-2" cols="12" xs="6" sm="6" md="12">
                                <app-text category="content-title">{{ $t(`${langPath}.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text> 
                                <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.text`) }}</app-text>                                                
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="12" class="d-flex pa-0 ma-0 mt-2 justify-end align-end">
                        <appbutton v-if="computedUsers.length !== '0' && form.site !== '' && form.site !== undefined && form.site !== null" label="PRINT ROLL CALL" icon="" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly"  @click.native="printRollCall(computedUsers)" />
                        <appbutton label="CANCEL ROLL CALL" icon="" type="error" iconclass="white--text" labelclass="white--text" showlabel="xlOnly"  @click.native="rollCallCloseDialog = true" />
                    </v-col>
                </v-row>
            </v-col>
            
            <v-col cols="12" class="pr-1">

                <!--Counters-->
                <div class="frcr-counter-container">
                
                    <!--Time taken-->
                    <!--Not for small screens-->
                    <div v-if="$vuetify.breakpoint.width > 424" class="ffrcr-counter" width="40">
                        <app-text category="text-small">TIME TAKEN</app-text>
                        <app-text category="text-default-bold"> {{ computedTimeTaken }} </app-text>
                    </div>

                    <v-divider v-if="$vuetify.breakpoint.width > 424" vertical/>
                    
                    <!--In-->
                    <div class="ffrcr-counter" width="20">
                        <app-text category="text-small">IN</app-text>
                        <app-text category="text-default-bold"> {{ computedSelectedUsersSwappedIn }} / {{ computedUsersSwappedIn }} </app-text>
                    </div>

                    <v-divider vertical/>

                    <!--Out-->
                    <div class="ffrcr-counter" width="20">
                        <app-text category="text-small">OUT</app-text>
                        <app-text category="text-default-bold"> {{ computedSelectedUsersSwappedOut }} / {{ computedUsersSwappedOut }} </app-text>
                    </div>

                    <v-divider vertical/>

                    <!--Total-->
                    <div class="ffrcr-counter" width="40">
                        <app-text category="text-small">TOTAL</app-text>
                        <app-text category="text-default-bold"> {{ computedSelectedUsersTotal }} / {{ computedUsersTotal }} </app-text>
                    </div>

                </div>

                <!--Time taken-->
                <!--Small screens only-->
                <div v-if="$vuetify.breakpoint.width <= 424" class="frcr-counter-container">
                    <div class="ffrcr-counter">
                        <app-text category="text-small">Time taken</app-text>
                        <app-text category="text-default-bold"> {{ computedTimeTaken }} </app-text>
                    </div>
                </div>
            </v-col>
        </v-row>

        <!--Form-->
        <v-form ref="form">
            <!--Search-->
            <v-row no-gutters class="pr-1">
                <!-- //* SEARCH -->
                <v-col class="pt-3 pr-lg-1 px-sm-0" cols="12" xs="12" sm="12" md="6">
                    <v-text-field background-color="white" v-model="search" prepend-inner-icon="icons8-search" filled dense :label="$t(`filters.search`)" clearable hide-details></v-text-field>
                </v-col>
                <!-- //* SITE -->
                <v-col class="pl-lg-1 pt-3" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                    <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" color="black" :label="$t(`fields.site`)" v-model="form.site" :items="sites" :rules="rules.site" item-text="value" item-value="value" required filled hide-details="auto" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}">
                        <template v-slot:item="data">{{ data.item.siteName }}</template>
		    			<template v-slot:selection="data">{{ data.item.siteName }}</template>
                    </v-select>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" class="pr-lg-1 pt-3">
                    <v-select :menu-props="{ top: false, offsetY: true }" :attach="true"  clearable background-color="white" v-model="filter.userType" :items="userTypes" item-text="text" item-value="value" filled dense clearable label="User Types" hide-details></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="6" class="pl-lg-1 pt-3">
                    <v-select :menu-props="{ top: false, offsetY: true }" :attach="true"  clearable background-color="white" v-model="filter.function" :items="functions" item-text="text" item-value="value" filled dense clearable label="Functions" hide-details></v-select>
                </v-col>
            </v-row>

            <!--User cards-->
            <div v-if="computedUsers.length !== 0 && form.site !== '' && form.site !== undefined && form.site !== null" class="frcr-grid pr-1">
                <div v-for="user in computedUsers" :key="user.id">

                    <fireRollCallUserCard v-on:fireRollCallSelection="handleUserSelection" :user="user"/>

                </div>
            </div>

            <v-divider class="my-4 mr-1"/>


            <!--Title | Type | Notes-->
            <v-row no-gutters class="pr-1">
                <!-- //* TITLE-->
                <v-col class="mb-2 pr-lg-1 " cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                    <v-text-field color="black" :label="$t(`fields.name`)" v-model="form.name" :rules="rules.name" required filled hide-details="auto" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}"></v-text-field>
                </v-col>

                <!-- //* TYPE-->
                <v-col class="mb-2 pl-lg-1 " cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                    <v-select color="black" :label="$t(`fields.type`)" v-model="form.type" :rules="rules.type" :items="['Drill', 'Emergency']" item-text="value" item-value="value" required filled hide-details="auto" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}"></v-select>
                </v-col>

                <!-- //* NOTES-->
                <v-col class="mb-2 mt-1" cols="12">
                    <v-textarea color="black" :label="$t(`fields.notes`)" v-model="form.notes"  filled hide-details="auto" rows="3" :background-color="formBackground" auto-grow dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}"></v-textarea>
                </v-col>
            </v-row>

            <!--Save button-->
            <div v-if="$vuetify.breakpoint.mdAndUp" class="d-flex text-right pb-6 pr-0">
                <v-spacer/>
                <appbutton @click.native="validateForm" :block="$vuetify.breakpoint.width < 600" class="mt-2 mr-0 pr-0" color="success" icon="icons8-save" label="Save Fire Roll Call"/>
            </div>
            <div v-else class="d-flex text-right pb-6 pr-2">
                <v-spacer/>
                <appbutton @click.native="validateForm" :block="$vuetify.breakpoint.width < 600" class="mt-2 mr-0 pr-0" color="success" icon="icons8-save" label="Save Fire Roll Call"/>
            </div>

        </v-form>
        <v-dialog v-model="rollCallCloseDialog" transition="dialog-bottom-transmission" max-width="512">
            <v-card class="">
                <v-toolbar color="primary" elevation=0>
                    <app-text category="text-medium" class="white--text ml-4">Cancel Fire Roll Call?</app-text>
                    <v-spacer />
                    <v-btn @click="rollCallCloseDialog = false" icon dark>
                        <v-icon class="icons8-multiply pr-2" color="white" />
                    </v-btn>
                </v-toolbar>

                <div class="pa-4">
                    <app-text category="text-default">By cancelling this Fire Role Call, you will lose all registered data and nothing will be recorded.
                        <br />
                        <br />
                        Are you sure you want to cancel?
                    </app-text>
                    <div class="d-flex mt-4">
                        <appbutton @click.native="rollCallCloseDialog = false" type="black" label="No, Keep" />
                        <v-spacer />
                        <appbutton @click.native="MIX_go('/fireRollCall')" type="grey" label="Yes, Delete" />
                    </div>
                </div>
            </v-card>

        </v-dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    name: "fireRollCallRegister",
    data: () => ({
        filterBySearch: '',
        langPath: 'firerollcall',
        form: {
            name: '',
            site: '',
            type: '',
            notes: '',
            timeTaken: 0,
            checkedUsers: [],
        },
        search: '', // Table Search
        filter: {
            site: '',
            userType: '',
            function: '',
        },
        formReadOnly: false,
        formMode: 'New',
        formBackground: 'white',
        timer: null,
        usersData: [],
        swappData: [],
        rollCallCloseDialog: false,
		sites: [], // Populated by GET_sites
        userTypes: [],
        functions: [ 'Production', 'Engineering', 'Shunters', 'Maintenance Control', 'Planning', 'Stores', 'Facilities', 'Train Presentation', 'Fleet Readiness'],
        rules: {}
    }),

    computed: {
        ...mapGetters({
            GET_help: 'GET_help',
			GET_sites: "GET_sites", // Get Sites,
            GET_lookupValues: 'GET_lookupValues',
        }),

        /**
         * Computed Users
         *
         * Sort the users array by the user's swapp status ('in' first), then alphabetically.
         *
         * @returns {Array} sorted list of users
         */
        computedUsers() {
            const t = this
            let users = t.usersData
            console.log('computing users = ' + JSON.stringify(users.length, null, 2))
            console.log('filters = ' + JSON.stringify(t.filter, null, 2))

            // Filter by Site
            if ((t.form.site !== '') && (t.form.site !== undefined) && (t.form.site !== null)) {
                users = users.filter(function(item) {
                    return t.form.site.siteId === item.lastSite.siteId;
                });
                users = users.filter(function(item) {
                    if (item.swappStatus === 0) {
                        var timeNow = t.$moment().format('X')
                        var timeMinus2 = t.$moment().subtract(2, 'hours').format('X')
                        // console.log("timeMinus2" + timeMinus2)
                        // console.log("itemSwappedTime" + item.swappedTime)
                        return item.swappedTime > timeMinus2
                    } else if (item.swappStatus === 1) {
                        return item
                    }
                })
                // Filter by search
                if (t.filterBySearch) {
                    users = users.filter(user => user.userName.toUpperCase().match(t.filterBySearch.toUpperCase()))
                }
                if (t.filter.userType) {
                    users = users.filter(user => user.userType === t.filter.userType)
                }
                if (t.filter.function) {
                    users = users.filter(function(user) {
                        if (user.function !== undefined) {
                            return user.function === t.filter.function || user.function.includes(t.filter.function)
                        }
                    })
                }
                // Filter by Search Mobile
                if (t.search !== '') {
                    users = users.filter(function(item) {
                        var itemName = item.userName.toUpperCase();
                        var search = t.search.toUpperCase();
                        return itemName.includes(search)
                    });
                }
                // Sort by SWAPP status, then alphabetically
                users.sort((a, b) => {

                    // Swapp - in first
                    if (a.swappStatus < b.swappStatus) return 1
                    if (a.swappStatus > b.swappStatus) return -1
                    // UserName - a-z
                    if (a.userName > b.userName) return 1
                    if (a.userName < b.userName) return -1

                })
                // t.matchUsersAndSwappLogs()
                console.log('computing users = ' + JSON.stringify(users.length, null, 2))
                return users
            } else {
                return []
            }
        },
        /** * Computed Selected Users Swapped In * * Returns the number of selected users that are SWAPPed in. * * @returns {number} */
        computedSelectedUsersSwappedIn() {
            const t = this

            return t.form.checkedUsers.filter(user => user.swappStatus === 1).length
        },

        /** * Computed Users Swapped In * * Returns the total number of SWAPPed in users. * * @returns {number} */
        computedUsersSwappedIn() {
            const t = this

            return t.computedUsers.filter(user => user.swappStatus === 1).length
        },
        /** * Computed Selected Users Swapped Out * * Returns the number of selected users that are SWAPPed out. * * @returns {number} */
        computedSelectedUsersSwappedOut() {
            const t = this

            return t.form.checkedUsers.filter(user => user.swappStatus === 0).length
        },
        /** * Computed Users Swapped Out * * Returns the total number of SWAPPed out users. * * @returns {number} */
        computedUsersSwappedOut() {
            const t = this

            return t.computedUsers.filter(user => user.swappStatus === 0).length
        },
        /** * Computed Selected Users Total * * Returns the number of selected users that are SWAPPed in or out. * * @returns {number} */
        computedSelectedUsersTotal() {
            const t = this

            return t.form.checkedUsers.length
        },
        /** * Computed Users Total * * Returns the total number of users. * * @returns {number} */
        computedUsersTotal() {
            const t = this

            return t.computedUsers.length
        },
        /** * Computed Time Taken * * Returns the time taken to complete the Fire Roll Call, formatted to H:MM:SS. * * @returns {string} */
        computedTimeTaken() {
            const t = this

            const timeInMillis = new Date(1000 * Math.round(t.form.timeTaken / 1000))
            return `
            ${timeInMillis.getUTCHours()} :
            ${('0' + timeInMillis.getUTCMinutes()).slice(-2)} :
            ${('0' + timeInMillis.getUTCSeconds()).slice(-2)}`
        },

    },

    methods: {
		...mapActions({ ACT_openItem: "ACT_openFireRollCall" }),

        printRollCall: async function(computedUsers) {
            var t = this;
            var item = {};
            // var itemResult = await t.MIX_readDocumentById(t.collection, id)
            item.data = computedUsers
            // console.log(JSON.stringify(item, null, 2))
            t.ACT_openItem(item);
            t.MIX_puDialog(true, 'printRollCall', '100vw', '100vh')
        },

        /** * Handle User Selection * * Add or remove the selected User to/from the checkedUsers array. */
        handleUserSelection(userPayload) {
            const t = this

            // If the user has been checked, uncheck them
            if (t.form.checkedUsers.some(user => user.id === userPayload.id && user.checked)) {
                delete userPayload.checked
                t.form.checkedUsers = t.form.checkedUsers.filter(user => user.id !== userPayload.id)
            }

            // If the user has not been checked, check them
            else {
                userPayload.checked = true
                t.form.checkedUsers.push(userPayload)
            }

        },
        // GET NOTICES SNAPSHOT METHOD
        getTableData: async function () {
            var t = this;
            var collection = t.$firebase.db.collection('users')
            t.customWhere = [];
            // console.log('getting users')
            
            if (JSON.stringify(t.customWhere) !== '[]') {
                for (var i = 0; i < t.customWhere.length; i++) {
                    var query = { field: t.customWhere[i].key, operator: t.customWhere[i].operator, value: t.customWhere[i].value }
                    collection = collection.where(query.field, query.operator, query.value)   
                }
            }

            collection.onSnapshot(function(querySnapshot) {
                t.usersData = [];
                querySnapshot.forEach(function(doc) {
                    var document = doc.data()
                    document.id = doc.id;
                    if (!document.hasOwnProperty('delete')) {
                        t.usersData.push(document);
                    } else if (t.showDeleted) {
                        t.usersData.push(document);
                    } else {
                        // Do not Show Concern
                    }
                });
                // console.log("usersData = " + JSON.stringify(t.usersData, null, 2))
            });
            // t.matchUsersAndSwappLogs()
            return;
        },
        // GET SWAPP LOGS
        getSwappLogs: async function() {
            var t = this;
            var collection = t.$firebase.db.collection('swappLogs')
            t.customWhere = [];

            if (JSON.stringify(t.customWhere) !== '[]') {
                for (var i = 0; i < t.customWhere.length; i++) {
                    var query = { field: t.customWhere[i].key, operator: t.customWhere[i].operator, value: t.customWhere[i].value }
                    collection = collection.where(query.field, query.operator, query.value)   
                }
            }

            collection.onSnapshot(function(querySnapshot) {
                t.swappData = [];
                querySnapshot.forEach(function(doc) {
                    var document = doc.data()
                    document.id = doc.id;
                    if (!document.hasOwnProperty('delete')) {
                        t.swappData.push(document);
                    } else if (t.showDeleted) {
                        t.swappData.push(document);
                    } else {

                    }
                })
            })
        },
        matchUsersAndSwappLogs() {
            var t = this;
            // console.log(JSON.stringify(t.usersData, null, 2))
            t.usersData.forEach(user => {
                let userSwappLog = t.swappData.filter(function(item) {
                    return item.swappedUser === user.id 
                })
                userSwappLog = userSwappLog.sort((a,b) => {
                    return a.modifiedDateTime < b.modifiedDateTime ? 1 : -1
                })
                user.lastSwappDateTime = userSwappLog.length ? userSwappLog[0].modifiedDateTime : 0
                // console.log(JSON.stringify(user.lastSwappDateTime, null, 2))
            })
            return t.usersData.filter(user => t.$moment(Number(user.lastSwappDateTime)).format('DD-MM-YYYY') === t.$moment().format('DD-MM-YYYY'))
        },
        // * VALIDATION RULES
		validateForm() {
			let t = this;
            t.rules = {
                site: [ v => !!v || 'Site Required'],
                name: [ v => !!v || "Name Required"],
                type: [ v => !!v || "Type Required"],
            }
            //let the DOM update
            t.$nextTick(() => {
                //manually trigger Vuetify validation
                if(t.$refs.form.validate()) {
                    this.saveItem();
                } else {
                    t.MIX_alert(-1, "Please fill out all the fields", null, null);
                }
                //if not valid, errors will be automatically displayed
            })
		},

        /** * Start Timer * * Starts the Fire Roll Call timer and updates timeTaken every second. */
        startTimer() {
            const t = this
            t.timer = setInterval(() => {
                t.form.timeTaken += 1000
            }, 1000)
        },

        /** * Stop Timer * * Stop and clear the timer. */
        stopTimer() {
            const t = this
            clearInterval(t.timer)
        },
		// SAVE ITEM
		saveItem: async function() {
			var t = this;
            if (t.form.id === undefined) {
                t.form.id = t.MIX_generateId();  // if new then generate new id
            }            
			var createDocumentResult = await t.MIX_createDocument('fireRollCall', t.form); // Create Document Within Firestore based on Form
			if (createDocumentResult.code === 1) {
				t.MIX_alert(1, `Fire Roll Call Saved`, null, null); // Send Success Alert to Item
				t.MIX_go('/fireRollCall')
			} else {
				t.MIX_alert(-1, `Error Saving Fire Roll Call`, null, null); // Send Error Alert to Item
			}
		},
        /** * Save Document * * Save a new Fire Rol Call with the form data. * If the document has saved successfully, call to close the register and refresh the page. * * @returns {Promise<void>} */
        async saveDocument() {
            const t = this
            const createDocument = await t.MIX_createDocument('fireRollCall', t.form)
            if (createDocument.code === 1) {
                t.$emit('emitCloseRegister')
                t.MIX_go('fireRollCall')
            }
        },

    },

    async mounted() {
        const t = this
        await t.getTableData()
        // await t.getSwappLogs()
        t.startTimer()

		// * GET SITES
		t.sites = t.GET_sites; // STORE SITES IN LOCAL ARRAY
        t.userTypes = await t.GET_lookupValues('USERTYPES');
    },

    /** * Before Destroy * * Kill any running processes. */
    beforeDestroy() {
        var t = this
        t.stopTimer()
    }

}
</script>

<style>
.frcr-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(calc(360px - 32px - 16px), 1fr)); /* width - page padding - scrollbar */
    grid-gap: 16px;

    margin-top: 16px;
}

.frcr-counter-container {
    display: flex;
    align-self: center;
    justify-content: center;
    grid-gap: 32px;

    background: white;
    border-radius: 5px;
    margin-top: 16px;
    padding: 8px 16px;
    width: calc(100%);
    z-index: 999;
}

.ffrcr-counter {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
